import React from "react"
import { Id, OperationsContainer, OrderLineInfo, Reason } from "./Shared.styled"
import { OrderDelivery } from "lib/types/generated/graphql-types"
import { useOrderTabContext } from "../../../../views/Orders/OrderViews/OrderTabContext"

type Props = {
  delivery: OrderDelivery
  orderLineId: string
}

const DeliveryInfo = ({ delivery, orderLineId }: Props) => {
  const { switchToUpdatesTab } = useOrderTabContext()

  const deliveredQuantity = delivery?.orderLines?.find(
    (ol) => ol.orderLineId === orderLineId
  )?.quantity

  return (
    <OperationsContainer>
      <div>
        <b>Delivery</b>{" "}
        <div>
          {delivery?.reason && (
            <Reason>
              {delivery?.reason?.code} - {delivery?.reason?.cause}
            </Reason>
          )}
        </div>{" "}
        <Id onClick={switchToUpdatesTab}>{delivery.id}</Id>
      </div>{" "}
      <div>
        <OrderLineInfo>
          <div>Delivered quantity:</div>
          <div>{deliveredQuantity}</div>
        </OrderLineInfo>
      </div>
    </OperationsContainer>
  )
}

export default DeliveryInfo
